const addDraggableMarker = (map, behavior, position, onChange) => {
  const { H } = window;
  const marker = new H.map.Marker(position, {
    volatility: true
  });

  marker.draggable = true;
  map.addObject(marker);


  map.addEventListener('dragstart', (ev) => {
    const { target, currentPointer } = ev;
    if (target instanceof H.map.Marker) {
      const targetPosition = map.geoToScreen(target.getGeometry());
      target.offset = new H.math.Point(currentPointer.viewportX - targetPosition.x, currentPointer.viewportY - targetPosition.y);
      behavior.disable();
    }
  }, false);

  map.addEventListener('dragend', (ev) => {
    const { target } = ev;
    if (target instanceof H.map.Marker) {
      behavior.enable();
      onChange(target.getGeometry())
    }
  }, false);

  map.addEventListener('drag', (ev) => {
    const { target, currentPointer } = ev;
    if (target instanceof H.map.Marker) {
      target.setGeometry(map.screenToGeo(currentPointer.viewportX - target.offset.x, currentPointer.viewportY - target.offset.y));
    }
  }, false);

  return marker;
};

export const addFocusButtonControl = (ui, onStateChange) => {
  const { H } = window;
  const focusButton = new H.ui.base.Button({
    label: `<svg viewBox="0 0 22 22" version="1.1" class="H_icon">
                <path d="M11.4545122,2.83119306 L11.4545122,4.63682972 C11.4545122,4.88784986 11.2510201,5.09134189
                 11,5.09134189 C10.7489799,5.09134189 10.5454878,4.88784986 10.5454878,4.63682972 L10.5454878,2.83119306
                 C6.38899291,3.05879244 3.05879244,6.38899291 2.83119306,10.5454878 L4.63682972,10.5454878 C4.88784986,10.5454878
                 5.09134189,10.7489799 5.09134189,11 C5.09134189,11.2510201 4.88784986,11.4545122 4.63682972,11.4545122 
                 L2.83119306,11.4545122 C3.05879244,15.6110071 6.38899291,18.9412076 10.5454878,19.1688069 L10.5454878,17.3631703
                 C10.5454878,17.1121501 10.7489799,16.9086581 11,16.9086581 C11.2510201,16.9086581 11.4545122,17.1121501 
                 11.4545122,17.3631703 L11.4545122,19.1688069 C15.6110071,18.9412076 18.9412076,15.6110071 19.1688069,11.4545122
                 L17.3631703,11.4545122 C17.1121501,11.4545122 16.9086581,11.2510201 16.9086581,11 C16.9086581,10.7489799 
                 17.1121501,10.5454878 17.3631703,10.5454878 L19.1688069,10.5454878 C18.9412076,6.38899291 15.6110071,3.05879244
                 11.4545122,2.83119306 Z M11,20.9992676 C5.47755701,20.9992676 1.00073242,16.522443 1.00073242,11 C1.00073242,5.47755701
                 5.47755701,1.00073242 11,1.00073242 C16.522443,1.00073242 20.9992676,5.47755701 20.9992676,11 C20.9992676,16.522443
                 16.522443,20.9992676 11,20.9992676 Z M11,13 C9.8954305,13 9,12.1045695 9,11 C9,9.8954305 9.8954305,9 11,9
                 C12.1045695,9 13,9.8954305 13,11 C13,12.1045695 12.1045695,13 11,13 Z" id="path-1"></path>
              </svg>`,
    onStateChange
  });

  const focusControl = new H.ui.Control();
  focusControl.addChild(focusButton);
  focusControl.setAlignment('right-bottom');
  ui.addControl('customControl', focusControl);
};

export const formatHereAddressLabel = (address: string) => {
  if (!address) return '';
  return Array.from(new Set(address.split(', '))).join(', ');
}

export default addDraggableMarker;
